
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable()
export class HttpClientService {

  constructor(private readonly httpClient : HttpClient) {
    this.getToken();
  }

  public getToken(): Observable<any> {
    // return this.httpClient.get(environment.tmsApiEndpointAddress + "token", {responseType: 'text'}).pipe(map((response : any) => {
    //   let token = response;
    //   localStorage.removeItem('basicToken');
    //   localStorage.setItem('basicToken', token);
    // }));
    return of("token") ;
  }

  public getApiVersion(): Observable<string> {
    return this.httpClient.get(environment.tmsApiEndpointAddress + "version").pipe(map((response : any) => {
      return response;
    }));
  }

  get(url) {
    return this.httpClient.get(url);
  }

  get1<T>(url) {
    return this.httpClient.get<T>(url);
  }

  getWithParams(url: string, params: HttpParams) {
    return this.httpClient.get(url, {params: params});
  }


  getWithConfig(url , config) {
    return this.httpClient.get(url , config);
  }



  post(url, data, responseType?) {
    if (responseType)
      return this.httpClient.post(url, data, {responseType:responseType});
    else
      return this.httpClient.post(url, data);
  }

  postWithConfig(url, data, config) {
    return this.httpClient.post(url, data, config);
  }

  put(url, data) {
    return this.httpClient.put(url, data);
  }

  putWithConfig(url, data, config) {
    return this.httpClient.put(url, data, config);
  }

  delete(url) {
    return this.httpClient.delete(url);
  }

  patch(url, data) {
    return this.httpClient.patch(url,data);
  }
}
